import { Component, OnInit } from '@angular/core';
import { AdvancedSearchService } from './advanced-search.service';
import { NotifierService } from 'angular-notifier';

@Component({
  selector: 'app-advanced-search',
  templateUrl: './advanced-search.component.html',
  styleUrls: ['./advanced-search.component.scss']
})
export class AdvancedSearchComponent implements OnInit {
  
  constructor(
    public aSearchservice: AdvancedSearchService,
    private notifier: NotifierService
  ) { }

  private scrollToInvalidField() {
    setTimeout(() => {
      const invalidField = document.querySelector('.invalid-field');
      if (invalidField) {
        invalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
        // Try to focus on the input or select inside the invalid field
        const inputElement = (invalidField as HTMLElement).querySelector('input, textarea, mat-select') as HTMLInputElement;
        if (inputElement) {
          inputElement.focus();
        }
      }
    }, 100);
  }

  ngOnInit(): void {
  }

  onSelectOperator(operator: string, index: number) {
    this.aSearchservice.appliedSearch[index].operator = operator;
    this.aSearchservice.clearInvalid(index);
  }

  onInputChange(value: string, index: number) {
    this.aSearchservice.appliedSearch[index].value = value;
    this.aSearchservice.clearInvalid(index);
    if (this.aSearchservice.appliedSearch.length === 1) {
      if (value.trim() === '') {
        this.aSearchservice.resetSearch();
      }
      // else{
      //   this.submitSearch();
      // }
    }
  }

  onTextChange(value: string) {
    if (value.trim() === '') {
      this.aSearchservice.resetSearch();
    }
    // else{
    //   this.submitSearch();
    // }
  }

  addNewFilter() {
    this.aSearchservice.appliedSearch.push({ value: '', operator: 'OR' });
    // Scroll to and focus on the newly added input field
    setTimeout(() => {
      const searchRows = document.querySelectorAll('.search-row');
      if (searchRows.length > 0) {
        const lastSearchRow = searchRows[searchRows.length - 1];
        const inputElement = lastSearchRow.querySelector('.search-text input') as HTMLInputElement;
        if (inputElement) {
          inputElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          inputElement.focus();
        }
      }
    }, 100);
  }

  removeFilter(index: number) {
    this.aSearchservice.removeAppliedSearch(index);
  }

  submitSearch() {
    if (this.aSearchservice.selectedTab === 'search-by-comma') {
      this.aSearchservice.appliedSearch = [{value: ''}];
      if (!this.aSearchservice.commaSearchStr || this.aSearchservice.commaSearchStr.trim() === '') {
        this.notifier.notify('error', 'Please enter a search value.');
        this.scrollToInvalidField();
        return;
      }
      let searchValues = this.aSearchservice.commaSearchStr.split(',').map(val => val.trim()).filter(val => val !== '');
      if (searchValues.length === 0) {
        this.notifier.notify('error', 'Please enter a search value.');
        this.scrollToInvalidField();
        return;
      }
      let commaAppliedSearch = searchValues.map(value => ({ value, operator: 'OR' }));
      delete commaAppliedSearch[0].operator;
      this.aSearchservice.onSearchSubmit(commaAppliedSearch);
      // this.aSearchservice.onStrSearchSubmit(commaAppliedSearch);
    }else {
      this.aSearchservice.commaSearchStr = '';
      const { valid, message } = this.aSearchservice.validateAppliedSearch();
      if (!valid) {
        this.notifier.notify('error', message);
        this.scrollToInvalidField();
        return;
      }
      this.aSearchservice.onSearchSubmit(this.aSearchservice.appliedSearch);
    }
  }

  onTabChange(tab: string) {
    this.aSearchservice.selectedTab = tab;
    // if (tab == 'search-by-comma') {
    //   this.aSearchservice.appliedSearch = [{value: ''}];
    // }else if (tab == 'search-by-operator'){
    //   this.aSearchservice.commaSearchStr = '';
    // }
  }
}
